
import { mapGetters, mapActions } from 'vuex';

import CustomModal from '../molecule/CustomModal.vue';
import CloseIcon from '../icons/CloseIcon.vue';
import UIPortfoliosDropdown from './UIPortfoliosDropdown.vue';
import StockOperationCard from '../molecule/StockOperationCard.vue';
import ArrowIcon from '../icons/ArrowIcon.vue';

export default {
  name: 'UIPortfolioSelectorModal',
  components: {
    CustomModal,
    CloseIcon,
    UIPortfoliosDropdown,
    StockOperationCard,
    ArrowIcon,
  },
  computed: {
    ...mapGetters('modals', ['portfolioSelectorModal']),

    portfolios() {
      return this.portfolioSelectorModal?.portfolios || [];
    },

    symbol() {
      return this.portfolioSelectorModal?.symbol ?? null;
    },
  },
  mounted() {
    if (this.portfolios.length > 0) {
      this.setSelectedPortfolio(this.portfolios[0]);
    }
  },
  methods: {
    ...mapActions('modals', [
      'closePortfolioSelectorModal',
      'setSelectedPortfolio',
    ]),
    closeModal() {
      this.closePortfolioSelectorModal();
    },
    onContinue() {
      this.closeModal();
      this.$emit('continue');
    },
    handlePortfolioChange(portfolio) {
      this.setSelectedPortfolio(portfolio);
    },
  },
};
